<div class="row mb-3 d-none d-lg-flex">
    <div class="col-xl-1 col-lg-2">
        <label
            for="participantTitle"
            class="col-form-label"
            translate="CONFIRMATION_PARTICIPANTLIST_TITLE_LABEL"
        ></label>
    </div>
    <div class="col-2">
        <label
            for="participantFirstname"
            class="col-form-label"
            translate="CONFIRMATION_PARTICIPANTLIST_FIRSTNAME_LABEL"
        ></label>
    </div>
    <div class="col-2">
        <label
            for="participantLastname"
            class="col-form-label"
            translate="CONFIRMATION_PARTICIPANTLIST_LASTNAME_LABEL"
        ></label>
    </div>
    <div class="col-3">
        <label
            for="participantEmail"
            class="col-form-label"
            translate="CONFIRMATION_PARTICIPANTLIST_EMAIL_LABEL"
        ></label>
    </div>
    @if (displayMobileNumber) {
        <div class="col-2">
            <label
                for="participantMobileNumber"
                class="col-form-label"
                translate="CONFIRMATION_PARTICIPANTLIST_MOBILE_NUMBER_LABEL"
            ></label>
        </div>
    }
    @if (!displayMobileNumber && isParticipantCreditTypeSelectorEnabled) {
        <div class="col-2 offset-lg-1 d-none d-xl-block">
            <label
                for="participantCreditType"
                class="col-form-label"
                translate="CONFIRMATION_PARTICIPANTLIST_ATTENDEETYPE_LABEL"
            ></label>
        </div>
    }
</div>

@if (model.participantList.value.length === 0) {
    <div class="text-center">
        <span translate="CONFIRMATION_SUMMARY_PARTICIPANT_NOT_AVAILABLE"></span>
    </div>
}

<div [formGroup]="participantsForm">
    @for (participant of model.participantList.value; track participant; let i = $index) {
        <fieldset class="mb-0 mb-lg-3">
            <div class="row gap-2 gap-lg-0 mb-3">
                <div class="col-12 mt-2 d-lg-none d-flex justify-content-end">
                    @if (!participant.isCustomData) {
                        <pace-core-checkbox-input
                            [(model)]="participant.isSelected"
                            [parentForm]="participantsFormChildren"
                            (valueChange)="participantSelectionChanged(participant)"
                            [ariaLabel]="
                                ('CONFIRMATION_PARTICIPANTLIST_SELECT_PARTICIPANT_ARIA_LABEL' | translate) + (i + 1)
                            "
                        ></pace-core-checkbox-input>
                    }
                    @if (participant.isCustomData) {
                        <button
                            type="button"
                            id="btnDelete"
                            class="btn btn-warning"
                            (click)="deleteParticipant(i)"
                            [attr.aria-label]="
                                ('CONFIRMATION_PARTICIPANTLIST_DELETE_PARTICIPANT_ARIA_LABEL' | translate) + (i + 1)
                            "
                        >
                            <fa-icon [icon]="faTrash"></fa-icon>
                        </button>
                    }
                </div>
                <div class="col-12 col-xl-1 col-lg-2">
                    <label
                        for="participantTitle"
                        class="col-form-label d-flex d-lg-none"
                        translate="CONFIRMATION_PARTICIPANTLIST_TITLE_LABEL"
                    ></label>
                    <pace-core-text-input
                        id="participantTitle"
                        [(model)]="participant.title"
                        [parentForm]="participantsFormChildren"
                        [ariaLabel]="'CONFIRMATION_PARTICIPANTLIST_TITLE_LABEL' | translate"
                    ></pace-core-text-input>
                </div>
                <div class="col-12 col-lg-2">
                    <label
                        for="participantFirstname"
                        class="col-form-label d-flex d-lg-none"
                        translate="CONFIRMATION_PARTICIPANTLIST_FIRSTNAME_LABEL"
                    ></label>
                    <pace-core-text-input
                        id="participantFirstname"
                        [(model)]="participant.firstName"
                        [parentForm]="participantsFormChildren"
                        [ariaLabel]="'CONFIRMATION_PARTICIPANTLIST_FIRSTNAME_LABEL' | translate"
                    ></pace-core-text-input>
                </div>
                <div class="col-12 col-lg-2">
                    <label
                        for="participantLastname"
                        class="col-form-label d-flex d-lg-none"
                        translate="CONFIRMATION_PARTICIPANTLIST_LASTNAME_LABEL"
                    ></label>
                    <pace-core-text-input
                        id="participantLastname"
                        [(model)]="participant.lastName"
                        [parentForm]="participantsFormChildren"
                        [ariaLabel]="'CONFIRMATION_PARTICIPANTLIST_LASTNAME_LABEL' | translate"
                    ></pace-core-text-input>
                </div>
                <div class="col-12 col-lg-3">
                    <label
                        for="participantEmail"
                        class="col-form-label d-flex d-lg-none"
                        translate="CONFIRMATION_PARTICIPANTLIST_EMAIL_LABEL"
                    ></label>
                    <pace-core-text-input
                        id="participantEmail"
                        [(model)]="participant.mail"
                        [parentForm]="participantsFormChildren"
                        [ariaLabel]="'CONFIRMATION_PARTICIPANTLIST_EMAIL_LABEL' | translate"
                    ></pace-core-text-input>
                </div>
                @if (displayMobileNumber) {
                    <div class="col-12 col-lg-2">
                        <label
                            for="participantMobileNumber"
                            class="col-form-label d-flex d-lg-none"
                            translate="CONFIRMATION_PARTICIPANTLIST_MOBILE_NUMBER_LABEL"
                        ></label>
                        <pace-core-text-input
                            id="participantMobileNumber"
                            [(model)]="participant.mobileNumber"
                            [parentForm]="participantsFormChildren"
                            [ariaLabel]="'CONFIRMATION_PARTICIPANTLIST_MOBILE_NUMBER_LABEL' | translate"
                        ></pace-core-text-input>
                    </div>
                }
                <div class="col-12 col-lg-1 mt-2 mt-lg-0 d-none d-lg-block">
                    @if (!participant.isCustomData) {
                        <pace-core-checkbox-input
                            [(model)]="participant.isSelected"
                            [parentForm]="participantsFormChildren"
                            (valueChange)="participantSelectionChanged(participant)"
                            [ariaLabel]="
                                ('CONFIRMATION_PARTICIPANTLIST_SELECT_PARTICIPANT_ARIA_LABEL' | translate) + (i + 1)
                            "
                        ></pace-core-checkbox-input>
                    }
                    @if (participant.isCustomData) {
                        <button
                            type="button"
                            id="btnDelete"
                            class="btn btn-warning"
                            (click)="deleteParticipant(i)"
                            [attr.aria-label]="
                                ('CONFIRMATION_PARTICIPANTLIST_DELETE_PARTICIPANT_ARIA_LABEL' | translate) + (i + 1)
                            "
                        >
                            <fa-icon [icon]="faTrash"></fa-icon>
                        </button>
                    }
                </div>
                @if (isParticipantCreditTypeSelectorEnabled) {
                    <div
                        class="col-12 mt-3 d-flex flex-column flex-lg-row align-items-lg-center"
                        [ngClass]="{ 'col-xl-3 mt-xl-0': !displayMobileNumber }"
                    >
                        <label
                            for="participantCreditType"
                            class="col-form-label d-flex me-lg-3"
                            [ngClass]="{ 'd-xl-none': !displayMobileNumber }"
                            translate="CONFIRMATION_PARTICIPANTLIST_ATTENDEETYPE_LABEL"
                        ></label>
                        <pace-core-radio-input
                            id="participantCreditType"
                            [(model)]="participant.creditType"
                            (valueChange)="participantCreditTypeChanged()"
                            [parentForm]="participantsFormChildren"
                        ></pace-core-radio-input>
                    </div>
                }
            </div>
            <hr class="separator d-block d-lg-none" />
        </fieldset>
    }
</div>
<hr class="separator d-none d-lg-block" />
<div class="row">
    <div class="col-12 d-flex">
        <button
            class="btn btn-primary ms-0 ms-lg-auto"
            (click)="addParticipant()"
            translate="CONFIRMATION_PARTICIPANTLIST_ADD_PARTICIPANT_LABEL"
        ></button>
    </div>
</div>
